/*eslint-disable*/
import React from "react";
import {
    Box,
    Flex, Heading, Image,
    Link,
    List,
    ListItem,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import logo from "../../assets/img/layout/logo-white.svg";

export default function Footer() {
    let textColor = useColorModeValue("gray.400", "white");
    let linkColor = useColorModeValue({base: "gray.400", lg: "white"}, "white");
    return (
        <Box bgColor={'brand.500'} color={'#fff'} p={"50px 25px"} marginTop="60px">
            <Flex gap={5} direction={{base: "column", lg: 'row'}} alignItems="stretch">
                <Box flex="1">
                    <Image src={logo} alt='ferienhaus.online' w='300px' mb='30px'/>
                    <Text>Auf den Seiten von ferienhaus.online stöbern jeden Monat hunderttausende Urlauber nach ihrer
                        idealen Unterkunft. Nutzen Sie die Gelegenheit und präsentieren Sie Ihr Ferienhaus oder Ihre
                        Ferienwohnung zum attraktiven Festpreis – ganz ohne Provisionsgebühren!
                    </Text>
                </Box>
                <Box flex="1">
                    <Heading size='md' mb={5} pb={5} borderBottom={'1px solid #fff'}>DRV & Deutscher
                        Ferienhausverband</Heading>
                    <Text>Wir sind Mitglied im Deutschen Ferienhausverband e. V. und im Deutschen Reiseverband e.V. Der
                        Deutsche Ferienhausverband mit Sitz in Berlin wurde im Dezember 2013 gegründet und ist
                        Deutschlands größter Branchenverband im Ferienhaussegment. Der Deutsche Reiseverband e.V. setzt
                        sich seit über 60 Jahren für die Interessen der Tourismusbranche ein.</Text>
                </Box>
            </Flex>
            <Flex mt={5} gap={5} direction={{base: "column", lg: 'row'}}>
                <Text
                    color={textColor}
                    mt={{base: "5", lg: "0px"}}>
                    {" "}
                    &copy; {1900 + new Date().getYear()}
                    <Text as='span' fontWeight='500' ms='4px'>NeoLodge GmbH, Remshalden</Text>
                </Text>
                <List display='flex'>
                    <ListItem
                        me={{
                            base: "20px",
                            md: "44px",
                        }}>
                        <Link
                            fontWeight='500'
                            color={linkColor}
                            href='https://ferienhaus.online/impressum/'
                            target='_blank'
                        >
                            Impressum
                        </Link>
                    </ListItem>
                    <ListItem
                        me={{
                            base: "20px",
                            md: "44px",
                        }}>
                        <Link
                            fontWeight='500'
                            color={linkColor}
                            href='https://ferienhaus.online/datenschutz/'
                            target='_blank'
                        >
                            Datenschutz
                        </Link>
                    </ListItem>
                    <ListItem
                        me={{
                            base: "20px",
                            md: "44px",
                        }}>
                        <Link
                            fontWeight='500'
                            color={linkColor}
                            href='https://ferienhaus.online/agbs/'
                            target='_blank'
                        >
                            AGBs
                        </Link>
                    </ListItem>
                </List>
            </Flex>
        </Box>
    );
}
